// base URL pointing to CRM API/legacy

export const baseUrl: string = process.env.VUE_APP_CRM_URL ?? '';
